<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.01332 15.1436C5.47756 13.3794 7.29696 9.96707 11.0333 9.06276M12.3787 8.85797C11.905 8.88997 11.4568 8.96025 11.0333 9.06276M7.60684 5.09549C6.81321 3.8992 5.39579 2.97249 4.26083 2.46175C0.648846 8.18072 4.5346 10.7488 6.66667 10.9997C9.13871 9.02204 8.56715 6.54305 7.60684 5.09549ZM7.60684 5.09549C7.49482 4.21757 8.1738 2.236 11.7858 1.33301C13.1654 3.22536 14.9463 7.42061 11.0333 9.06276"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
    />
  </svg>
</template>
